(function () {
  var ROOT_SEL = '[data-floor-stack-root]';
  var CARD_SEL = '.floor-stack-cards__card';
  var CARD_SPECIAL_SEL = '.floor-stack-cards__card--special';
  var SCENE_SEL = '.floor-stack-cards__scene';

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function parsePhases(root) {
    var sum = parseFloat(root.getAttribute('data-fsc-phase-sum') || '100', 10);
    if (!sum || Number.isNaN(sum)) sum = 100;
    var read = parseFloat(root.getAttribute('data-fsc-read') || '48', 10) / sum;
    var exit = parseFloat(root.getAttribute('data-fsc-exit') || '18', 10) / sum;
    var pause = parseFloat(root.getAttribute('data-fsc-pause') || '14', 10) / sum;
    var enter = parseFloat(root.getAttribute('data-fsc-enter') || '20', 10) / sum;
    var t = read + exit + pause + enter;
    if (t <= 0) {
      return { read: 0.48, exit: 0.18, pause: 0.14, enter: 0.2 };
    }
    return {
      read: read / t,
      exit: exit / t,
      pause: pause / t,
      enter: enter / t,
    };
  }

  function transformForMode(mode, t, isEnter) {
    var e = easeInOutCubic(clamp(t, 0, 1));
    if (mode === 'fade') {
      return { ty: 0, tx: 0, sc: 1 };
    }
    var ty = 0;
    var tx = 0;
    var sc = 1;
    if (mode === 'fade_slide_up') {
      ty = isEnter ? (1 - e) * 64 : -e * 64;
    } else if (mode === 'fade_slide_down') {
      ty = isEnter ? -(1 - e) * 64 : e * 64;
    } else if (mode === 'fade_slide_left') {
      tx = isEnter ? (1 - e) * 52 : -e * 52;
    } else if (mode === 'fade_slide_right') {
      tx = isEnter ? -(1 - e) * 52 : e * 52;
    } else if (mode === 'fade_scale') {
      sc = isEnter ? 0.9 + 0.1 * e : 1 - 0.1 * e;
    } else if (mode === 'fade_zoom') {
      sc = isEnter ? 0.86 + 0.14 * e : 1 - 0.14 * e;
    } else {
      ty = isEnter ? (1 - e) * 64 : -e * 64;
    }
    return { ty: ty, tx: tx, sc: sc };
  }

  function computeCardState(i, p, n, s, phases, mode) {
    var read = phases.read;
    var exit = Math.max(phases.exit, 1e-6);
    var pause = phases.pause;
    var enter = Math.max(phases.enter, 1e-6);
    var enterStart = read + exit + pause;
    var enterLen = enter;

    if (n === 1) {
      return { op: 1, ty: 0, tx: 0, sc: 1 };
    }

    if (i === n - 1) {
      if (p < (n - 1) * s) {
        var uPrevLast = (p - (n - 2) * s) / s;
        if (uPrevLast >= enterStart) {
          var tIn = clamp((uPrevLast - enterStart) / enterLen, 0, 1);
          var tr = transformForMode(mode, tIn, true);
          return { op: easeInOutCubic(tIn), ty: tr.ty, tx: tr.tx, sc: tr.sc };
        }
        return { op: 0, ty: 0, tx: 0, sc: 1 };
      }
      return { op: 1, ty: 0, tx: 0, sc: 1 };
    }

    if (i === 0) {
      if (p >= s) {
        return { op: 0, ty: 0, tx: 0, sc: 1 };
      }
      var u0 = p / s;
      if (u0 <= read) {
        return { op: 1, ty: 0, tx: 0, sc: 1 };
      }
      if (u0 <= read + exit) {
        var tEx = (u0 - read) / exit;
        var tr0 = transformForMode(mode, tEx, false);
        return { op: 1 - easeInOutCubic(tEx), ty: tr0.ty, tx: tr0.tx, sc: tr0.sc };
      }
      return { op: 0, ty: 0, tx: 0, sc: 1 };
    }

    var op = 0;
    var ty = 0;
    var tx = 0;
    var sc = 1;

    if (p < i * s) {
      var uPrev = (p - (i - 1) * s) / s;
      if (uPrev >= enterStart) {
        var tE = clamp((uPrev - enterStart) / enterLen, 0, 1);
        var trE = transformForMode(mode, tE, true);
        op = easeInOutCubic(tE);
        ty = trE.ty;
        tx = trE.tx;
        sc = trE.sc;
      }
    }

    if (p >= i * s && p < (i + 1) * s) {
      var u = (p - i * s) / s;
      if (u <= read) {
        op = Math.max(op, 1);
        ty = 0;
        tx = 0;
        sc = 1;
      } else if (u <= read + exit) {
        var tX = (u - read) / exit;
        var trX = transformForMode(mode, tX, false);
        var opX = 1 - easeInOutCubic(tX);
        if (opX >= op - 1e-4) {
          op = opX;
          ty = trX.ty;
          tx = trX.tx;
          sc = trX.sc;
        }
      }
    }

    return { op: clamp(op, 0, 1), ty: ty, tx: tx, sc: sc };
  }

  function reducedMotionState(i, p, n) {
    var s = 1 / n;
    var k = clamp(Math.floor((p + 1e-8) / s), 0, n - 1);
    return {
      op: i === k ? 1 : 0,
      ty: 0,
      tx: 0,
      sc: 1,
    };
  }

  function clearCardStyles(cards) {
    cards.forEach(function (card) {
      card.style.transform = '';
      card.style.opacity = '';
      card.style.pointerEvents = '';
      card.style.zIndex = '';
    });
  }

  function attachIntroStickySync(root) {
    var section = root.closest('[id^="shopify-section-"]');
    if (!section) return null;

    var intro = section.querySelector('.floor-stack-cards__intro--sticky');
    if (!intro) {
      section.style.removeProperty('--fsc-card-sticky-extra-top');
      return null;
    }

    function apply() {
      var h = Math.round(intro.getBoundingClientRect().height);
      section.style.setProperty('--fsc-card-sticky-extra-top', h + 'px');
    }

    apply();

    function onResize() {
      apply();
    }

    window.addEventListener('resize', onResize, { passive: true });

    var ro = null;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(function () {
        apply();
      });
      ro.observe(intro);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(apply).catch(function () {});
    }

    return function cleanupIntroStickySync() {
      window.removeEventListener('resize', onResize);
      if (ro) ro.disconnect();
      section.style.removeProperty('--fsc-card-sticky-extra-top');
    };
  }

  function attachBoardTilt(root, sceneHandlers, variant) {
    var special = variant === 'special';
    var mult = special ? 12 : 10;
    var rx = special ? 0.4 : 0.35;
    var ry = special ? 0.5 : 0.45;
    var shadowX = special ? 0.8 : 1;
    var shadowY = special ? 0.7 : 0.6;

    root.querySelectorAll(SCENE_SEL).forEach(function (scene) {
      function onMove(e) {
        if (window.innerWidth <= 860) return;

        var rect = scene.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * mult;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * mult;

        scene.style.transform =
          'rotateX(' + -y * rx + 'deg) rotateY(' + x * ry + 'deg)';
        var shadow = scene.querySelector('.floor-stack-cards__board-shadow');
        if (shadow) {
          shadow.style.transform =
            'translate(' +
            x * shadowX +
            'px, ' +
            (18 + y * shadowY) +
            'px) scaleX(1.04)';
        }
      }

      function onLeave() {
        scene.style.transform = 'rotateX(0deg) rotateY(0deg)';
        var shadow = scene.querySelector('.floor-stack-cards__board-shadow');
        if (shadow) {
          shadow.style.transform = 'translateY(18px) scaleX(1.04)';
        }
      }

      scene.addEventListener('mousemove', onMove);
      scene.addEventListener('mouseleave', onLeave);
      sceneHandlers.push({ scene: scene, onMove: onMove, onLeave: onLeave });
    });
  }

  function cleanupScenes(sceneHandlers) {
    sceneHandlers.forEach(function (h) {
      h.scene.removeEventListener('mousemove', h.onMove);
      h.scene.removeEventListener('mouseleave', h.onLeave);
      h.scene.style.transform = '';
      var shadow = h.scene.querySelector('.floor-stack-cards__board-shadow');
      if (shadow) shadow.style.transform = '';
    });
    sceneHandlers.length = 0;
  }

  function initSpecial(root) {
    if (!root || root.dataset.floorStackInit === '1') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll(CARD_SPECIAL_SEL));
    if (!cards.length) return;

    root.dataset.floorStackInit = '1';

    var tiltEnabled = root.getAttribute('data-floor-stack-tilt') !== 'false';
    var threshold = parseFloat(root.getAttribute('data-fsc-io-threshold') || '0.2', 10);
    if (Number.isNaN(threshold)) threshold = 0.2;

    var sceneHandlers = [];
    var io = null;
    var reduceMotion = prefersReducedMotion();

    if (reduceMotion) {
      cards.forEach(function (c) {
        c.classList.add('in-view');
      });
    } else {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
            }
          });
        },
        { threshold: threshold, rootMargin: '0px 0px -6% 0px' }
      );
      cards.forEach(function (c) {
        io.observe(c);
      });
    }

    if (tiltEnabled && !reduceMotion) {
      attachBoardTilt(root, sceneHandlers, 'special');
    }

    var introCleanup = attachIntroStickySync(root);

    root._floorStackCleanup = function () {
      if (io) {
        io.disconnect();
        io = null;
      }
      cards.forEach(function (c) {
        c.classList.remove('in-view');
      });
      cleanupScenes(sceneHandlers);
      if (introCleanup) introCleanup();
      delete root.dataset.floorStackInit;
      delete root._floorStackCleanup;
    };
  }

  function init(root) {
    if (!root || root.dataset.floorStackInit === '1') return;

    if (root.getAttribute('data-floor-stack-mode') === 'special') {
      initSpecial(root);
      return;
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll(CARD_SEL));
    if (!cards.length) return;

    root.dataset.floorStackInit = '1';

    var tiltEnabled = root.getAttribute('data-floor-stack-tilt') !== 'false';
    var mode = root.getAttribute('data-floor-stack-transition') || 'fade_slide_up';
    var phases = parsePhases(root);
    var sceneHandlers = [];

    var reduceMotion = prefersReducedMotion();

    function updateStackScroll() {
      var rect = root.getBoundingClientRect();
      var total = root.offsetHeight - window.innerHeight;
      if (total <= 0) total = 1;
      var progress = clamp(-rect.top / total, 0, 1);

      var n = cards.length;
      var s = 1 / n;

      cards.forEach(function (card, i) {
        var st = reduceMotion
          ? reducedMotionState(i, progress, n)
          : computeCardState(i, progress, n, s, phases, mode);

        card.style.opacity = String(st.op);
        card.style.transform =
          'translate(' + st.tx + 'px, ' + st.ty + 'px) scale(' + st.sc + ')';
        card.style.pointerEvents = st.op < 0.02 ? 'none' : '';
        card.style.zIndex = String(10 + Math.round(st.op * 50) + i);
      });
    }

    function onScroll() {
      updateStackScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateStackScroll();

    if (tiltEnabled && !reduceMotion) {
      attachBoardTilt(root, sceneHandlers, 'default');
    }

    var introCleanup = attachIntroStickySync(root);

    root._floorStackCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      cleanupScenes(sceneHandlers);
      if (introCleanup) introCleanup();
      delete root.dataset.floorStackInit;
      clearCardStyles(cards);
      delete root._floorStackCleanup;
    };
  }

  function scan(doc) {
    (doc || document).querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var sec = ev.target;
    if (!sec || typeof sec.querySelector !== 'function') return;
    scan(sec);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var sec = ev.target;
    if (!sec || typeof sec.querySelector !== 'function') return;
    var r = sec.querySelector(ROOT_SEL);
    if (r && typeof r._floorStackCleanup === 'function') {
      r._floorStackCleanup();
    }
  });
})();
